import { Box, Button, Flex, Image, Text, border } from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  BsBlockquoteRight,
  BsClipboard2Check,
  BsPencil,
  BsPhone,
} from "react-icons/bs";
import { IoColorPaletteOutline } from "react-icons/io5";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import InvitationBg from "../../../../assets/CustomizeInvitationBG.png";
import CustomizationButton from "../../../../assets/customizeButton.png";
import { BASE_URL_MEDIA, BASE_URL_USER } from "../../../../Redux/App/action";

const CustomizeInvitation = () => {
  const params = useParams();
  const id = params._id;
  localStorage.setItem("cardid", id);
  let user = localStorage.getItem("user");
  const accessToken = localStorage.getItem("token");
  const navigate = useNavigate();
  const [customCard, setCustomCards] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [customize, setCustomize] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const onImageLoad = ({ target: img }) => {
    setDimensions({
      width: img.offsetWidth,
      height: img.offsetHeight,
    });
  };
  const getCustomData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_MEDIA}/canvas/get/canvastemplate?sourceMediaId=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setCustomCards(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
  };
  const getProfileData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      if (response.status === 200) {
        setProfileData(response.data.payload);
      }
    } catch (error) {
      console.clear(error);
    }
  };
  const eventId = localStorage.getItem("eventId");
  const handleCustomize = () => {
    if (user) {
      if (eventId) {
        navigate(`/canvas/${id}/${eventId}`);
      } else {
        navigate(`/canvas/${id}`);
      }
    } else {
      navigate("/authenticate", {
        state: { invite: window.location.pathname },
      });
    }
  };

  useEffect(() => {
    getCustomData();
    getProfileData();
  }, []);

  return (
    <Box h={{ md: "100%", base: "100%" }} p={1}>
      <Flex
        w={"95%"}
        m={"auto"}
        flexDirection={{ md: "row", base: "column" }}
        h={"full"}
        mt={"10"}
        mb={"10"}
        boxShadow={
          "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;"
        }
        bgImage={InvitationBg}
      >
        <Flex
          w={{ md: "100%", base: "100%" }}
          borderLeftRadius={40}
          flexDirection={{ base: "column", md: "row" }}
          justifyContent={"space-evenly"}
          gap={{ md: 10, base: 0 }}
        >
          <Box mb={{ md: 5 }}>
            {customCard &&
              customCard.map((el, i) => (
                <>
                  {el.mediaType === "TEMPLATE_PREVIEW" ? (
                    <Image
                      p={"6"}
                      src={el.imageUrl}
                      m={"auto"}
                      h={{ md: 700, base: 400 }}
                      key={i}
                      onLoad={onImageLoad}
                      mb={{ md: 2 }}
                    />
                  ) : null}
                </>
              ))}
          </Box>
          <Flex
            gap={5}
            w={{ md: customize ? "100%" : "50%", base: "100%" }}
            justifyContent={"center"}
          >
            <Box w={"100%"}>
              <Flex mt={{ md: 5 }} alignItems={"center"}>
                <Image
                  src={CustomizationButton}
                  alt={"Customize"}
                  onClick={handleCustomize}
                  w={{ md: "50%", base: "80%" }}
                  h={{ md: "50%", base: "80%" }}
                  margin={"auto"}
                  cursor={"pointer"}
                />
              </Flex>
              <>
                <Box mt={5} w={"100%"} textAlign={"left"} className="lato-font">
                  <Text
                    fontSize={{ md: 18, base: 10 }}
                    m={"auto"}
                    w={{ md: "80%", base: "90%" }}
                  >
                    Wishfy offers an{" "}
                    <Text
                      as={"span"}
                      bgGradient="linear(to-r, red.400,pink.400)"
                      bgClip="text"
                    >
                      elegant Greetings card
                    </Text>{" "}
                    with text in cursive writing and colorful painted. This card
                    allows for a personalized message on the back. Perfect for
                    ecards, online Greeting cards, or emailed invitations.
                  </Text>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"space-between"}
                    mt={4}
                    alignItems={"center"}
                  >
                    <IoColorPaletteOutline size={70} />
                    <Text fontSize={{ md: 18, base: 10 }}>
                      Change your Card’s text, style, envelope, stamp, backdrop,
                      and more. Add additional text boxes where you want them.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"space-between"}
                    mt={2}
                    alignItems={"center"}
                  >
                    <BsPencil size={50} />
                    <Text fontSize={{ md: 18, base: 10 }}>
                      Personalize with your event’s details, make or import a
                      guest list, and send with a click.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"space-between"}
                    mt={2}
                    alignItems={"center"}
                  >
                    <BsBlockquoteRight size={50} />
                    <Text fontSize={{ md: 18, base: 10 }}>
                      Use customizable Blocks for schedule, registry,
                      accommodations, travel details, and more.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"space-between"}
                    mt={2}
                    fontSize={{ md: 18, base: 10 }}
                    alignItems={"center"}
                  >
                    <BsPhone size={50} />
                    <Text fontSize={{ md: 18, base: 10 }}>
                      Send your way, via email, text message, or a shareable
                      link you can paste and post anywhere.
                    </Text>
                  </Flex>
                  <Flex
                    gap={5}
                    w={"80%"}
                    m={"auto"}
                    justifyContent={"space-between"}
                    mt={2}
                    alignItems={"center"}
                  >
                    <BsClipboard2Check size={50} />
                    <Text fontSize={{ md: 18, base: 10 }}>
                      Instantly track opens and RSVPs, communicate with
                      invitees, and use the app to check guests in on-site.
                    </Text>
                  </Flex>
                </Box>
              </>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default CustomizeInvitation;
